module.exports = __webpack_public_path__ + "media/img/home/directions/mobile/direction3-29b1b95ae26bb8862e174f9ed95cb73a.svg";